import PropTypes from 'prop-types';
import constants from '../../../config/constants';
import { withLabels } from '../../../utils/LabelsContext';
import { DeliveryErrorStyles } from './DeliveryErrorDisplay.style';

const { AVAILABILITY_HOMEDELIVERY, AVAILABILITY_PICKUPINSTORE, AVAILABILITY_STOCKINSTORE } = constants;

const DeliveryErrorDisplay = ({ errorState, comunaName, selectedType }) => {
  const getErrorMessage = (deliveryType, errorCode) => {
    const errorMessages = {
      [AVAILABILITY_HOMEDELIVERY]: {
        NO_DELIVERY_SLOTS: `Revisa la disponibilidad del producto seleccionando la opción de retiro o en tienda.`,
        DEFAULT: `No pudimos obtener información de envío a domicilio para ${comunaName || 'tu zona'}.`,
      },
      [AVAILABILITY_PICKUPINSTORE]: {
        NO_PICKUP_SLOTS: `Revisa la disponibilidad del producto en otra comuna o selecciona la opción de envío o retiro.`,
        DEFAULT: `No pudimos obtener información de retiro en punto para ${comunaName || 'tu zona'}.`,
      },
      [AVAILABILITY_STOCKINSTORE]: {
        STORES_NOT_FOUND: `Intenta con otra comuna o revisa disponibilidad de envío o retiro en un punto.`,
        DEFAULT: `No pudimos obtener información de stock en tiendas para ${comunaName || 'tu zona'}.`,
      },
    };

    const typeMessages = errorMessages[deliveryType];
    return typeMessages ? typeMessages[errorCode] || typeMessages.DEFAULT : 'Ocurrió un error inesperado.';
  };

  const getErrorTitle = (deliveryType) => {
    const titles = {
      [AVAILABILITY_HOMEDELIVERY]: 'No disponible para envío.',
      [AVAILABILITY_PICKUPINSTORE]: 'No disponible para retiro.',
      [AVAILABILITY_STOCKINSTORE]: `No disponible en tiendas de ${comunaName || 'tu zona'}`,
    };
    return titles[deliveryType] || 'Servicio no disponible';
  };

  const activeErrors = Object.entries(errorState)
    .filter(([, value]) => value.isError)
    .map(([key, value]) => {
      let deliveryType;
      if (key === 'HomeDelivery') {
        deliveryType = AVAILABILITY_HOMEDELIVERY;
      } else if (key === 'PickupInStore') {
        deliveryType = AVAILABILITY_PICKUPINSTORE;
      } else {
        deliveryType = AVAILABILITY_STOCKINSTORE;
      }

      return {
        type: key,
        code: value.code,
        deliveryType,
      };
    });

  if (activeErrors.length === 0) return null;
  const filteredError = activeErrors.find((error) => error.type === selectedType);
  const { deliveryType, code } = filteredError;

  return (
    <div className="delivery-errors-container">
      <div className="delivery-error-item">
        <div className="title-container">
          <span className="error-icon" />
          <h4 className="error-title">{getErrorTitle(deliveryType)}</h4>
        </div>
        <div className="error-content">
          <p className="error-message">{getErrorMessage(deliveryType, code)}</p>
        </div>
      </div>
      <style jsx>{DeliveryErrorStyles}</style>
    </div>
  );
};

DeliveryErrorDisplay.propTypes = {
  errorState: PropTypes.shape({
    PickupInStore: PropTypes.shape({
      isError: PropTypes.bool.isRequired,
      code: PropTypes.string,
    }).isRequired,
    HomeDelivery: PropTypes.shape({
      isError: PropTypes.bool.isRequired,
      code: PropTypes.string,
    }).isRequired,
    StockInStore: PropTypes.shape({
      isError: PropTypes.bool.isRequired,
      code: PropTypes.string,
    }).isRequired,
  }).isRequired,
  comunaName: PropTypes.string,
  selectedType: PropTypes.string.isRequired,
};

DeliveryErrorDisplay.defaultProps = {
  comunaName: '',
};

export default withLabels(DeliveryErrorDisplay);
